import { AtomicItemListType } from 'shared/src/api';
import type { IScreensComponent } from 'shared/src/api/screensService/getScreens/types';

// 해당 마켓 상품 추천 구좌의 서버 컴포넌트 번호. GOODS_DETAIL atomic 응답은
// component_id 가 전부 동일(167)이라 proxy url path 로 판별한다.
const SAME_MARKET_PROXY_URL_SEGMENT = '/components/176/';

export const isSameMarketProxyComponent = (
  component: IScreensComponent,
): boolean =>
  component.type.itemList === AtomicItemListType.Proxy &&
  Boolean(
    component.entity.body?.item?.url?.includes(SAME_MARKET_PROXY_URL_SEGMENT),
  );
